<template>
  <div
    class="font-poppins antialiased bg-white dark:bg-slate-950 text-slate-950 dark:text-slate-100 tracking-normal"
  >
    <!-- GREEN BUBBLE SHADOW  -->
    <!-- <div
      class="absolute opacity-60 dark:opacity-50 z-20 -top-10 left-20 md:top-0 md:left-0 inset-x-0 flex justify-center overflow-hidden pointer-events-none"
    >
      <div class="md:h-auto md:w-[100rem] w-[20rem] h-[20rem] flex-none flex justify-end">
        <picture class="md:w-[50rem] md:flex-none md:max-w-none">
          <source
            media="(max-width: 767px)"
            srcset="/images/shadow-mobile.webp"
            height="652"
            width="652"
          />
          <source
            media="(min-width: 768px)"
            srcset="/images/shadow-b.webp"
            width="1375"
            height="916"
          />
          <img src="/images/shadow-b.webp" alt="shadow" />
        </picture>
      </div>
    </div> -->
    <div
      class="flex min-h-screen flex-col justify-between overflow-x-clip"
    >
      <!-- Site header-->
      <Header />
      <TrialSignupDialog />
      <DemoRequestDialog />
      <slot />
      <PageVideo />
      <!-- Site Footer-->
      <LazyFooter :hydrate-on-visible="{ rootMargin: '200px' }" />
    </div>
  </div>
</template>
